import { Component, Input } from '@angular/core';
import { LoadingController, NavController, ModalController } from '@ionic/angular';
import { SessionProvider } from '../../../../../providers/session/session';
import { TournamentService, PlanEnum, PlanOptions } from '../../services/tournament.service';
import { MeKoPage } from './new-plan/me-ko/me-ko';
import { PlanKoPage } from './new-plan/plan-ko/plan-ko';
import { PlanOnePage } from './new-plan/plan-one/plan-one';
import { PreRoundKoPage } from './new-plan/pre-round-ko/pre-round-ko';
import { PreRoundPage } from './new-plan/pre-round/pre-round';
import { TwoGruppeKoPage } from './new-plan/two-group-ko/two-group-ko';
import { TwoGKoPlPage } from './new-plan/twog-ko-pl/twog-ko-pl';
import { Router } from '@angular/router';

/**
 * Neuer Spielplan
 */

@Component({
  selector: 'new-tou-main',
  templateUrl: 'new-tou-main.html',
  styleUrls:['./new-tou-main.scss']
})
export class NewTouMainPage {
  planList = PlanOptions;

  constructor(
    public navCtrl: NavController,
    private sessionService: SessionProvider,
    private loadingCtrl: LoadingController,
    private gs: TournamentService,
    public viewCtrl: ModalController,
    private router:Router
  ) { }

  click(id: number) {
    let route = '';

    switch (id) {
      case PlanEnum.PlanOnePage: route = '/gamer/new-tou/plan-one'; break;

      case PlanEnum.KoPage: route = '/gamer/new-tou'; break;
      case PlanEnum.VorPage: route = '/gamer/new-tou/pre-round'; break;
      case PlanEnum.VorKoPage: route = '/gamer/new-tou/pre-round-ko'; break;
      case PlanEnum.GruKoPage: route = '/gamer/new-tou/two-group-ko'; break;
      case PlanEnum.GruKoPlPage: route = '/gamer/new-tou/twog-ko-pl'; break;
      case PlanEnum.MePage: route = '/gamer/new-tou/me-ko'; break;
    }

    if (route) {
      this.navCtrl.navigateForward(route);
    }
  }
  // click(id: number) {
  //   let page = null;
  //   switch (id) {
  //     case PlanEnum.PlanOnePage: page = PlanOnePage; break;
  //     case PlanEnum.KoPage: page = PlanKoPage; break;
  //     case PlanEnum.VorPage: page = PreRoundPage; break;
  //     case PlanEnum.VorKoPage: page = PreRoundKoPage; break;
  //     case PlanEnum.GruKoPage: page = TwoGruppeKoPage; break;
  //     case PlanEnum.GruKoPlPage: page = TwoGKoPlPage; break;
  //     case PlanEnum.MePage: page = MeKoPage; break;
  //   };
  //   this.navCtrl.push(page);
  // }
  dismiss(option) {
    this.viewCtrl.dismiss(option);
  }

  ionViewWillEnter() {
    // if (this.sessionService.isLoged) {
    //   let loader = this.loadingCtrl.create({});
    //   loader.present();
    //   this.gs.getPlanList().then(t => {
    //     console.log('----[NEW_PLAN_PAGE]:ionViewWillEnter-----');
    //     loader.dismiss();
    //     this.gs.$planListChangeSub.next();
    //   }).catch(e => {
    //     loader.dismiss();
    //   });
    // }
  }
}



